import $ from 'jquery';

import App from 'libs/app';

// module for handling copyrights with urls
App.registerReadyHandler("imageRights", function () {
    $("body").on("click", ".copyright[data-url]", function (evt) {
        evt.preventDefault();
        evt.stopPropagation();
        window.location = $(this).data("url");
    });

    // if the copyright has a parent a, try to disable its
    // hover styles by setting the "no-hover" class
    $("body").on("mouseenter", ".copyright[data-url]", function (evt) {
        $(this).parents("a").addClass("no-hover");
    }).on("mouseleave", ".copyright[data-url]", function (evt) {
        $(this).parents("a").removeClass("no-hover");
    });
});